import type { Immutable } from "immer";
import React from "react";

import { Context, templates } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import styles from "./index.module.scss";

export const StoryPageBody = (
    props: Immutable<Pick<templates.StoryPageTemplate, "mattress_url">>,
): React.JSX.Element => {
    const staticBase = React.useContext(Context).chrome.static_base;
    return (
        <>
            <section
                className={concatClassNames([styles.hero, "hero"])}
                style={{
                    background: `url(${staticBase}img/story/hero-story.jpg)`,
                }}
            >
                <div className="main-container">
                    <h1>Sealy knows mattresses and how people sleep.</h1>
                </div>
            </section>

            <section className={styles.storyQuote}>
                <div className="main-container">
                    <img
                        src={`${staticBase}img/story/story-user-jp.jpg`}
                        alt="Cocoon by Sealy -- Designed and tested"
                        loading="lazy"
                        decoding="async"
                    />
                    <h5>JP Gwaltney, Engineer, 2 years at Sealy</h5>
                    <h2>We wanted to do it right.</h2>
                    <p>
                        We designed and tested over 100 prototypes during our
                        two-year journey to develop a shippable mattress that
                        measures up to Sealy&rsquo;s standards of quality and
                        durability.&#34;
                    </p>
                </div>
            </section>

            <section className={styles.storyBillboard}>
                <img
                    src={`${staticBase}img/story/story-billboard--1.jpg`}
                    alt="Cocoon by Sealy"
                    loading="lazy"
                    decoding="async"
                />
            </section>

            <section className={styles.storyQuote}>
                <div className="main-container">
                    <img
                        src={`${staticBase}img/story/story-user-leigh.jpg`}
                        alt="Cocoon by Sealy -- In-house design, development"
                        loading="lazy"
                        decoding="async"
                    />
                    <h5>Leigh Morrison, Designer, 16 years at Sealy</h5>
                    <h2>In-house design, development, and manufacturing.</h2>
                    <p>
                        We control the entire production process, from the
                        high-quality materials used to the finished product, so
                        you can trust that the Cocoon&trade; by Sealy is a
                        superior quality bed.&#34;
                    </p>
                </div>
            </section>

            <section className={styles.storyBillboard}>
                <img
                    src={`${staticBase}img/story/story-billboard--2.jpg`}
                    alt="Cocoon by Sealy -- Our quality testing"
                    loading="lazy"
                    decoding="async"
                />
            </section>

            <section className={styles.storyQuote}>
                <div className="main-container">
                    <img
                        src={`${staticBase}img/story/story-user-allen.jpg`}
                        alt="Cocoon by Sealy -- Our quality testing is unmatched."
                        loading="lazy"
                        decoding="async"
                    />
                    <h5>Allen Platek, Head of R&amp;D, 20 years at Sealy</h5>
                    <h2>
                        Not all mattresses are created equal. Our quality
                        testing is unmatched.
                    </h2>
                    <p>
                        Our flagship testing center in North Carolina performs
                        proprietary and patented tests to ensure Sealy&rsquo;s
                        mattresses exceed standards and are built to last. Our
                        mattresses are tested for durability, comfort life,
                        safety/flammability, and even the effects of packaging,
                        shipping and handling.&#34;
                    </p>
                </div>
            </section>

            <section className={styles.storyBillboard}>
                <img
                    src={`${staticBase}img/story/story-billboard-4.jpg`}
                    alt="Cocoon by Sealy -- Our mattresses are tested for durability, comfort life, safety/flammability, and even the effects of packaging, shipping and handling."
                    loading="lazy"
                    decoding="async"
                />
            </section>

            <section className={styles.storyCenter}>
                <div className="main-container">
                    <h4>Trinity, NC</h4>
                    <h3>The Sealy Testing Center</h3>
                    <p>
                        The &ldquo;Rollator Surface Fatigue&rdquo; and
                        &ldquo;Mattress Durability Impact Test&rdquo; use 225
                        lbs of force over and over to evaluate how our
                        mattresses stand up to wear and tear. The Cocoon&trade;
                        by Sealy has been tested on over 100,000 cycles of
                        each&mdash;simulating 10 years of use&mdash;to ensure
                        our product lives up to our guarantee.
                    </p>
                    <div
                        className={concatClassNames([
                            styles.storyCenterCallout,
                            "play-on-view",
                        ])}
                    >
                        <img
                            src={`${staticBase}img/story/story-sealy-testing-center.jpg`}
                            alt="Cocoon by Sealy -- The 'Rollator Surface Fatigue' and 'Mattress Durability Impact Test'."
                            loading="lazy"
                            decoding="async"
                        />
                    </div>
                </div>
            </section>

            <section className="cta-block stitch-bg">
                <div className="main-container">
                    <h2>
                        Transform your <strong>Bed</strong>room&trade; Today.
                    </h2>
                    <a
                        className="button al-buy-now-btn"
                        href={props.mattress_url}
                        id="buy-now-btn"
                    >
                        Buy Now
                    </a>
                </div>
            </section>
        </>
    );
};
